/**
 * Alerta
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {AlertaCollection} from '@/model/collection/AlertaCollection'

/* TODO: review generated class */
export class Alerta extends Resource {
  idAlertaPk: number = 0

  descricao: string | null = null

  ativo: boolean | null = null

  get $id() {
    return this.idAlertaPk
  }
  set $id(val) {
    this.idAlertaPk = val
  }

  /**
   * Gets a instance of a given ID of Alerta
   */
  async getAlerta(id: number) {
    return await Request.get(`/admin/alerta/${id}`)
      .name('getAlerta')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of Alerta
   */
  async removeAlerta() {
    return await Request.delete(`/admin/alerta/${this.$id}`)
      .name('removeAlerta')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of Alerta
   */
  static async listAlerta(params: any) {
    return await Request.get(`/admin/alerta`, {params})
      .name('listAlerta')
      .as(AlertaCollection)
      .getData()
  }

  /**
   * Persists a new instance of Alerta. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistAlerta() {
    return await Request.post(`/admin/alerta`, this)
      .name('persistAlerta')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of Alerta to use it in a CSV file
   */
  static async listCsvAlerta(params: any) {
    return await Request.get(`/admin/alerta/csv`, {params})
      .name('listCsvAlerta')
      .as(AlertaCollection)
      .getData()
  }
}
